import { types } from './actions'

const createReducer = (handlers) => (state, action) => {
  if (!handlers.hasOwnProperty(action.type)) {
    return state
  }

  return handlers[action.type](state, action)
}

export default createReducer({
  [types.SAVE_SOURCE_FROM_UTM]: (state, { payload }) => {
    return {
      ...state,
      utm_source: payload.source,
    }
  },
  [types.SET_AUTHENTICATED]: (state, { payload }) => {
    return {
      ...state,
      auth: {
        ...payload,
        signInLinkLoaded:
          payload.signInLinkLoaded ?? state.auth.signInLinkLoaded,
        loaded:
          payload.firebaseLoaded &&
          (payload.signInLinkLoaded ?? state.auth.signInLinkLoaded),
      },
    }
  },
  [types.RESET_USERDATA]: (
    state,
    { payload: { loading, firebaseLoaded, signInLinkLoaded } },
  ) => {
    return {
      ...state,
      auth: {
        user: null,
        token: null,
        isAuthenticated: false,
        loading,
        firebaseLoaded,
        signInLinkLoaded: signInLinkLoaded ?? state.auth.signInLinkLoaded,
        loaded:
          firebaseLoaded && (signInLinkLoaded ?? state.auth.signInLinkLoaded),
      },
      userDataLoaded: false,
      userDataLoading: false,
      userDataError: false,
      userData: false,
      airbnbDataLoaded: false,
      airbnbDataLoading: false,
      airbnbData: false,
      airbnbDataError: false,
    }
  },
  [types.SET_SIGNINLINK_LOADED]: (state, { payload: { signInLinkLoaded } }) => {
    return {
      ...state,
      auth: {
        ...state.auth,
        signInLinkLoaded,
        loaded: state.auth.firebaseLoaded && signInLinkLoaded,
      },
    }
  },
  [types.SET_LOGIN_INFO]: (state, { payload: { loginEmail, loginKey } }) => {
    return {
      ...state,
      loginEmail,
      loginKey,
    }
  },
  [types.SAVE_QUERY_PARAMS]: (state, { payload: { amount, amountType } }) => {
    return {
      ...state,
      amountType: amountType ? amountType : state.amountType,
      amount: amount ? amount : state.amount,
      queryParamsSet: true,
    }
  },
  [types.SAVE_CHECKFORM_INPUTS]: (state, { payload }) => {
    return {
      ...state,
      checkFormData: payload,
    }
  },
  [types.FETCH_USERDATA_START]: (state, { payload }) => {
    return {
      ...state,
      userDataLoaded: false,
      userDataLoading: true,
    }
  },
  [types.SET_AIRBNB_STRONGER_TOGETHER_BANNER_OPEN]: (
    state,
    { payload: { open } },
  ) => {
    return {
      ...state,
      airbnb: {
        ...state.airbnb,
        strongerTogetherBannerOpen: open,
      },
    }
  },
  // called after submitting form
  [types.SET_AIRBNB_DATA_FROM_FORM]: (
    state,
    { payload: { key, loginKey, fullName, email, activeReferralLink } },
  ) => {
    return {
      ...state,
      airbnbData: {
        key: key,
        loginKey: loginKey,
        contact: {
          fullName,
          email,
        },
        activeReferralLink,
        referralCounts: { referralV3: 0, referralV2: 0, referral: 0 },
      },
    }
  },
  [types.SET_AIRBNB_FORM_DONE]: (state) => {
    return {
      ...state,
      airbnbData: {
        ...state.airbnbData,
        completed: true,
      },
    }
  },
  [types.FETCH_USERDATA_END]: (state, { error, payload }) => {
    const { lastStepDone } = payload.claim[0].agencyFeeClaim
    return {
      ...state,
      userDataLoaded: !error,
      userDataError: error,
      userDataLoading: false,
      submissionComplete: !error && payload && lastStepDone === 'signature',
      userData: payload,
    }
  },
  [types.SET_PROMOCODE_AND_REFERRALCODE]: (
    state,
    { payload: { promoCode, referralCode, referralCodeValid } },
  ) => {
    return {
      ...state,
      promoCode,
      referralCode,
      referralCodeValid,
    }
  },
  [types.SET_AIRBNB_RECEIPTS]: (state, { payload }) => {
    return {
      ...state,
      airbnbReceipts: payload,
    }
  },
  [types.DELETE_AIRBNB_RECEIPT]: (state, { payload: { id } }) => {
    return {
      ...state,
      airbnbReceipts: state.airbnbReceipts.filter(
        (receipt) => receipt.id !== id,
      ),
    }
  },
  [types.FETCH_AIRBNBDATA_START]: (state, { payload }) => {
    return {
      ...state,
      airbnbDataLoaded: false,
      airbnbDataLoading: true,
    }
  },
  [types.FETCH_AIRBNBDATA_END]: (state, { error, payload }) => {
    return {
      ...state,
      airbnbDataLoaded: !error,
      airbnbDataError: error,
      airbnbDataLoading: false,
      airbnbData: payload,
    }
  },
  [types.SET_NOTICE_SETTINGS]: (state, { payload }) => {
    return {
      ...state,
      noticeSettings: payload,
    }
  },
  [types.SET_NOTICE_HIDDEN]: (state, { payload }) => {
    return {
      ...state,
      noticeSettings: { ...state.noticeSettings, hidden: payload },
    }
  },
  [types.SET_NOTICE_BLOCKING]: (state, { payload }) => {
    return {
      ...state,
      noticeSettings: { ...state.noticeSettings, blocking: payload },
    }
  },
})
